import { Box, Typography, Paper, Button, Chip, Stack } from "@mui/material";
import { Add } from "@mui/icons-material";
import { BaseModalComponent } from "../../../common/BaseModalComponent";
import { colors } from "../../../ui/colors";
import { useGlobalSnackbar } from "../../../../context/SnackbarContext";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks/redux";
import { selectQuoteList } from "../../../../redux/features/quotes/quoteListSlice";
import { store } from "../../../../redux/store";
import { quoteCreateActions } from "../../../../redux/features/quotes/quote-create-advanced";
import { shouldBlockAdvancedQuoteCloseForMissingPrice } from "../helper/quoteServicePricingGate";
import { QuoteAdvancedRow } from "./components/QuoteAdvancedRow";
import { QuoteLayout } from "../Quote.layout";

export function QuoteAdvancedList() {
  const { showSnackbar } = useGlobalSnackbar();
  const dispatch = useAppDispatch();
  const advancedQuoteList = useAppSelector(selectQuoteList);
  const { clearAdvancedListEditContext } = quoteCreateActions;

  const handleConfirmCloseAddAdvancedModal = () => {
    const quoteCreate = store.getState().quoteCreate;
    if (shouldBlockAdvancedQuoteCloseForMissingPrice(quoteCreate)) {
      showSnackbar("Set an agreed price greater than zero on the summary before closing.", "warning", 5000, "top-center");
      return false;
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Stack spacing={1.5}>
        {advancedQuoteList.map((payload, index) => (
          <QuoteAdvancedRow key={payload.id} payload={payload} index={index} />
        ))}
      </Stack>

      <BaseModalComponent
        defaultSizes={{}}
        defaultFullscreen={false}
        onConfirmClose={handleConfirmCloseAddAdvancedModal}
        modalKey="modal-adv-add"
        modalLabel="Advanced Quote"
        elementTrigger={
          <Button
            fullWidth
            startIcon={<Add />}
            variant="outlined"
            onClick={() => dispatch(clearAdvancedListEditContext(undefined))}
            sx={{
              py: 1.5,
              mt: 1.5,
              borderRadius: 2,
              borderStyle: "dashed",
              borderWidth: 1.5,
              borderColor: colors.gray[300],
              color: colors.gray[600],
              textTransform: "none",
              fontWeight: 700,
              fontSize: 14,
              "&:hover": {
                borderColor: colors.orange.base,
                backgroundColor: `${colors.orange.base}08`,
                color: colors.orange.base,
                borderStyle: "dashed",
              },
            }}
          >
            Add Another Service
          </Button>
        }
      >
        <QuoteLayout />
      </BaseModalComponent>
    </Box>
  );
}
